export default __webpack_public_path__ + "static/media/school_design_hat.ce80a797.png";